module.exports = __webpack_public_path__ + "static/32DCAF_2_0-51f5bdb5b23e6629401ec7329eab56d2.woff2";